import { useNavigate } from "@tanstack/react-router"
import { getRefreshToken } from "./refreshTokenStorage"
import { useLogoutMutation } from "./api"
import { clearAuth } from "./slice"
import { withRefreshLock } from "./refreshLock"
import { useDispatch } from "@/base/store"
import baseApi from "@/base/baseApi"

export default () => {
  const [logout] = useLogoutMutation()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  return async () => {
    await navigate({ to: "/" }) // Avoids storing redirectUrl

    // Reading the token, invalidating it and clearing the store are one turn, under the lock every
    // other write of the shared token takes. Outside it, a refresh already in flight elsewhere
    // lands after the store is cleared and writes its replacement back — leaving a working token
    // behind for a session that was just signed out.
    await withRefreshLock(async () => {
      const refreshToken = getRefreshToken()
      if (refreshToken) {
        await logout(refreshToken)
      }
      dispatch(clearAuth())
    })

    dispatch(baseApi.util.resetApiState())
  }
}
